type FlatErrors = Record<string, string[]>;
type GroupedErrors = Record<string, Array<Record<string, string[]>>>;

const GROUP_MAP: Record<string, string> = {
  cdftheader: 'header',
  cdftxmtwhvtest: 'xmasWellhead',
  cdftsssvdbt: 'sssv',
  CdftAnnulusPressureReport: 'annulus',
  cdftcontrollinetest: 'controlLineTest',
  cdftsubsidencemonitoring: 'subsidenceMonitoring'
  // add more mappings here if needed
};

export function groupErrors(errors: FlatErrors): GroupedErrors {
  const grouped: GroupedErrors = {};

  // Matches: Prefix[Idx].Field  OR  Prefix.Field  OR  Prefix[Idx]
  // Examples:
  //  - "CdftHeader.InjectionRateMmscfD"
  //  - "CdftXmtWhvTest[0].Greasing"
  const rx = /^([^[.\]]+)(?:\[(\d+)\])?(?:\.(.+))?$/;

  for (const [rawKey, messages] of Object.entries(errors)) {
    const m = rx.exec(rawKey);
    if (!m) continue;

    const [, prefixRaw, indexRaw, fieldRaw] = m;
    const prefix = (prefixRaw || '').toLowerCase();
    const groupKey = GROUP_MAP[prefix] ?? prefix; // map known prefixes; fallback to lowercase
    const idx = indexRaw ? Number(indexRaw) : 0;  // default to 0 if no index
    const field = fieldRaw || '';                 // may be empty if no trailing field

    // Ensure the group array exists
    if (!Array.isArray(grouped[groupKey])) {
      grouped[groupKey] = [];
    }
    // Ensure the object at the desired index exists
    ensureIndex(grouped[groupKey], idx);

    // Attach messages
    if (field) {
      grouped[groupKey][idx][field] = messages;
    } else {
      // If no field name (rare), keep under a generic key
      grouped[groupKey][idx]['_errors'] = (grouped[groupKey][idx]['_errors'] || []).concat(messages);
    }
  }

  return grouped;
}

function ensureIndex(arr: Array<Record<string, string[]>>, idx: number) {
  while (arr.length <= idx) arr.push({});
}
